import { AUTH_GOOGLE } from "@/store/actions/auth";

export default function useGoogleAuth(vm) {
  let googleButtonWrapper = null;

  const handleCredentialResponse = async (response) => {
    if (response.credential && !vm.isRequesting) {
      vm.isRequesting = true;
      try {
        await vm.$store.dispatch(AUTH_GOOGLE, { credential: response.credential });
        vm.$router.push({ path: "/main" });
      } catch (err) {
        if (vm.passwordMessage) {
          vm.passwordMessage = vm.$t('AUTH_ERROR_' + err.code);
        }
      }
      vm.isRequesting = false;
    }
  };

  const handleGoogleLogin = () => {
    googleButtonWrapper.click();
  };

  const createFakeGoogleWrapper = () => {
    const googleLoginWrapper = document.createElement("div");
    googleLoginWrapper.style.display = "none";
    googleLoginWrapper.classList.add("custom-google-button");
    document.body.appendChild(googleLoginWrapper);

    window.google.accounts.id.renderButton(googleLoginWrapper, {
      type: "icon",
      width: "200",
    });

    const googleLoginWrapperButton = googleLoginWrapper.querySelector("div[role=button]");
    return {
      click: () => {
        googleLoginWrapperButton.click();
      },
    };
  };

  const initGoogleAuth = () => {
    const gClientId = "127640128797-dj0ifmjvpl05t21o2k7fijvtqs5o36cu.apps.googleusercontent.com";
    window.google.accounts.id.initialize({
      client_id: gClientId,
      ux_mode: "popup",
      callback: handleCredentialResponse,
    });

    googleButtonWrapper = createFakeGoogleWrapper();
  };

  return {
    initGoogleAuth,
    handleGoogleLogin,
  };
} 